import Vue from 'vue'
import Vuex from 'vuex'
import {
  fetchData
} from '../axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    refMsisdn: '',
    acceptanceId: '',
    rafContentList: {},
    messages: {},
    locale: 'gr',
    fullLocale: 'el_GR',
    termsUrl: '',
  },
  mutations: {
    setRefMsisdn (state, refMsisdn) {
      state.refMsisdn = refMsisdn
    },
    setAcceptanceId (state, acceptanceId) {
      state.acceptanceId = acceptanceId
    },
    setRafContentList (state, rafContentList) {
      state.rafContentList = rafContentList
    },
    setMessages (state, messages) {
      state.messages = messages
    },
    setLocale (state, locale) {
      state.locale = locale
    },
    setFullLocale (state, fullLocale) {
      state.fullLocale = fullLocale
    },
    setTermsUrl (state, termsUrl) {
      state.termsUrl = termsUrl
    }
  },
  actions: {
    loadMessages({
      commit
    }, locale) {
      // const lang = locale === 'el_GR' ? 'gr' : 'en'

      fetchData(
        'get',
        // `/${lang}/vueContentService/referafriend/`
        `/sites/Satellite/?pagename=fetchVueTranslationsEntry&ciKey=referafriend&locale=${locale}`
      )
        .then(async function (response) {
          if (response.data) {
            commit('setMessages', response.data)
            const srg = {}
            srg[locale] = response.data
            sessionStorage.messages = JSON.stringify(srg)
          } else {
            // window.location.replace('/')
            console.log('error');
          }
        })
        .catch(function () {
          // console.log(err)
          // window.location.replace('/')
          console.log('error');
        })
    },
    setRefMsisdn ({ commit }, refMsisdn) {
      commit('setRefMsisdn', refMsisdn)
    },
    setAcceptanceId ({ commit }, acceptanceId) {
      commit('setAcceptanceId', acceptanceId)
    },
    setRafContentList ({ commit }, rafContentList) {
      commit('setRafContentList', rafContentList)
    },
    setLocale ({ commit }, locale) {
      commit('setLocale', locale)
    },
    setFullLocale ({ commit }, fullLocale) {
      commit('setFullLocale', fullLocale)
    }
  },
  getters: {
    getRefMsisdn (state) {
      return state.refMsisdn
    },
    getAcceptanceId (state) {
      return state.acceptanceId
    },
    getRafContentList (state) {
      return state.rafContentList
    },
    getMessages (state) {
      return state.messages
    },
    getLocale (state) {
      return state.locale
    },
    getFullLocale (state) {
      return state.fullLocale
    },
    getTermsUrl (state) {
      return state.termsUrl
    }
  },
  modules: {
  }
})
